import { render, staticRenderFns } from "./DomainsField.vue?vue&type=template&id=61aae250&scoped=true&"
import script from "./DomainsField.vue?vue&type=script&lang=ts&"
export * from "./DomainsField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aae250",
  null
  
)

export default component.exports